// SR-CUSTOM: guard the theme's GridySlider against out-of-range slide indexes.
//
// When a slider holds no more slides than fit on screen (e.g. a short product
// gallery on a wide screen), autoplay/arrows compute a negative "last slide to
// show" and ask for slides[-n]. updateActiveSlide/scrollToSlide then read
// .classList / .offsetLeft of undefined and throw on every autoplay tick.
// Rather than edit the vendor global.js, clamp the index here.
(function () {
  var Gridy = customElements.get('gridy-slider');
  if (!Gridy || Gridy.prototype.__srGuarded) return;
  var proto = Gridy.prototype;
  proto.__srGuarded = true;

  function clamp(self, i) {
    var n = self.slides ? self.slides.length : 0;
    if (!n || isNaN(i)) return null;
    return Math.max(0, Math.min(n - 1, i));
  }

  var origScrollBy = proto.scrollByIPR;
  proto.scrollByIPR = function (direction) {
    // Nothing to scroll when every slide is already in view.
    if (this.config && this.config.slide_count <= this.config.currentIPR) return;
    return origScrollBy.call(this, direction);
  };

  var origScrollTo = proto.scrollToSlide;
  proto.scrollToSlide = function (pos, behavior) {
    var i = clamp(this, pos);
    if (i === null) return;
    return origScrollTo.call(this, i, behavior);
  };

  var origUpdate = proto.updateActiveSlide;
  proto.updateActiveSlide = function (pos) {
    var i = clamp(this, pos);
    if (i === null) return;
    if (this.config && this.indicator_elements && this.indicator_elements.length) {
      this.config.current_slide = Math.max(0, Math.min(this.indicator_elements.length - 1, this.config.current_slide || 0));
    }
    return origUpdate.call(this, i);
  };
})();
